export enum PowerOfAttorneyHolderType {
    PERSON = 1,
    TWO_PERSONS = 2,
    COMPANY = 3,
}
